import { useIsEnterpriseUser } from '#pplx/frontend/auth/useIsEnterpriseUser.js';
import { useWebPlatform } from '#pplx/frontend/platform-components/useWebPlatform.js';
import { isMobileWebView } from '#pplx/frontend/user-agent-parser/device.js';
/**
 * Whether the web account switcher (and the add-account action) should be available.
 *
 * The per-tab `X-Pplx-Account` model works in any standard browser — including Comet and mobile
 * web — so those are allowed. It's gated off only where that model doesn't apply: the **native
 * mobile app** (a webview), which has its own token-based multi-account, and the **Windows app**,
 * which isn't a standard web tab (RFC §7.3). It's also hidden on the enterprise subdomain for org
 * members (RFC §7.2): opted-in orgs don't allow adding or switching to personal accounts.
 */
export function useAccountSwitcherEnabled() {
    const isEnterpriseUser = useIsEnterpriseUser();
    const { device: { isWindowsApp, userAgent }, env: { isSingleTenant }, } = useWebPlatform();
    if (isWindowsApp || isMobileWebView(userAgent)) {
        return false;
    }
    if (isSingleTenant && isEnterpriseUser) {
        return false;
    }
    return true;
}
//# sourceMappingURL=useAccountSwitcherEnabled.js.map